<template lang="pug">
.app_container
  .mailbox_text {{ marketingConsentMessage }}

  .img_box
    img.logo_img(:src="imgSrc")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    imgSrc: String,
    marketingConsentMessage: String,
  }
})
class marketingComponents extends Vue {}

export default marketingComponents
</script>

<style lang="sass" scoped>
.app_container
  padding: 0 30px

.mailbox_text
  margin: 26px 0
  font-size: 16px
  text-align: center
  font-weight: 500

.img_box
  text-align: center

.logo_img
  width: 100%
</style>